export default __webpack_public_path__ + "static/media/solutions_visual_thermal.51b3ed6c.png";